module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-03.d9222cd22907000f34abe13679cd8816.png";